<script>
import { required, numeric } from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import formdate from "../formcomponet/formdate.vue";
import forminput from "../formcomponet/forminput.vue";
import formcombobox from "../formcomponet/formcombobox.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import omalzemeAddEdit from "../omalzeme/addedit.vue";
import BirimSecimi from "@/router/views/formcomponet/birimsecimi.vue";
export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Talep",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    formdate,
    forminput,
    formcombobox,
    Treeselect,
    omalzemeAddEdit,
    BirimSecimi
  },
  data() {
    return {
      title: this.$t("toplutalep.Title"),
      items: [
        {
          text: this.$t("toplutalep.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("toplutalep.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("toplutalep.Title"),
          active: true,
        },
      ],
      FormData: {
        Baslik: null,
        Taleptarih: null,
        Sartnameurl: null,
        Birimidler: [],
        Birimid: null,
        Kullanicitasinirid: null,
        Kullanicigerceklestirmeid: null,
        Kullaniciharcamaid: null,
        Sartnametip: [],
        Harcamatipid: null,
        Onaydurum: 1,
        Taleptoplamasontarih: null,
      },
      Birimler: [],
      Olcubirimleri: [],
      Kullanicilar: [],
      Harcamatipleri: [],
      Sartnametipleri: [],
      FormDataMalzeme: {
        Aciklama: null,
        Talepid: null,
        Grupid: null,
        Olcubirimi: null,
        Malzemeid: null,
        Depokarsilananadet: 0,
        Onaydurum: 3,
        Sirano: 1,
        Adet: 0,
      },
      MalzemeGruplari: [],
      Malzemeler: [],
      MalzemeListesi: [],
      MalzemeFullList: [],
      MalzmeEkle: false,
      TalepAddEdit: "",

      limit: 0,
    };
  },

  validations: {
    FormData: {
      Baslik: { required },
      Taleptarih: { required },
      Birimidler: { required },
      Kullanicitasinirid: {},
      Kullanicigerceklestirmeid: {},
      Kullaniciharcamaid: {},
      Harcamatipid: {  },
      Sartnametip: {  },
      Taleptoplamasontarih: { required },
    },

    FormDataMalzeme: {
      Aciklama: {},
      Grupid: {},
      Olcubirimi: {},
      Malzemeid: { required },
      Sirano: { required, numeric },
      Adet: { required, numeric },
    }
  },
  methods: {

    onSubmit() {
      this.$v.FormData.$touch();
      if (!this.$v.FormData.$invalid) {
        var kontrol = true
        for (var i = 0; i < this.FormData.Birimidler.length; i++) {
          this.FormData.Birimid = this.FormData.Birimidler[i]
          this.ActionsSingleGet({
            Service: "obirim",
            Id: this.FormData.Birimidler[i],
          }).then((birim) => {
            if (birim.Data.Eposta1) {
              let MailData = {
                Message: "Toplu talep listesi biriminize gönderildi. Veri Girişi İçin Son Tarih " + this.FormData.Taleptoplamasontarih,
                Recievermailadress: birim.Data.Eposta1,
                Subject: "Satın Alma Otomasyonu Bilgilendirme",
              };
              this.Post("TsvBildirimTanim/SendInvite", MailData).then((resp) => {
                console.log(resp)
              });
            }
          });
          this.Post("sattalep", this.FormData, false).then((sattalepid) => {
            if (sattalepid) {
              for (var j = 0; j < this.MalzemeListesi.length; j++) {
                this.MalzemeListesi[j].Talepid = sattalepid;


              }
              this.Post("sattalepmalzeme/postlist", this.MalzemeListesi, false).then((sattalepid) => {
                if (!sattalepid)
                  kontrol = false

                if (this.FormData.Birimidler.length == i) {
                  this.FormData = {
                    Baslik: null,
                    Taleptarih: null,
                    Sartnameurl: null,
                    Birimidler: [],
                    Birimid: null,
                    Kullanicitasinirid: null,
                    Kullanicigerceklestirmeid: null,
                    Kullaniciharcamaid: null,
                    Sartnametip: [],
                    Harcamatipid: null,
                    Onaydurum: 1,
                    Deleted: false,
                  }
                  this.MalzemeListesi = []
                }
              });
            }
            else {
              kontrol = false
            }
          });
        }
        if (kontrol) {

          this.$toast.success(this.$t("ToasMessage.PostPozitif"));

        }
        else {
          this.$toast.error(this.$t("ToasMessage.PostNegatif"));

        }

      }
    },
    onSubmitMalzeme() {
      this.$v.FormDataMalzeme.$touch();
      if (!this.$v.FormDataMalzeme.$invalid) {
        var data = JSON.stringify(this.FormDataMalzeme)
        data = JSON.parse(data)
        this.MalzemeListesi.push(data)
        this.FormDataMalzeme = {
          Aciklama: null,
          Talepid: null,
          Grupid: null,
          Olcubirimi: null,
          Malzemeid: null,
          Depokarsilananadet: 0,
          Onaydurum: 3,
          Sirano: 1,
          Adet: 1,
        }
      }
    },
    MalzemeDelete(index) {
      this.MalzemeListesi.splice(index, 1);

    },
    Get() {

    },
    malzeme_olcubirimi(Id){
      this.ActionsSingleGet({ Service: "OMalzeme", Id: Id }).then((res) => {
        this.FormDataMalzeme.Olcubirimi = res.Data.Olcubirimi;

      });
    },
    malzemeleri_yukle(Grupid) {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
      };
      this.Malzemeler = []
      this.ActionsFilterGet({ Service: "OMalzeme", Page: Page, Filter: "&Grupid=" + Grupid }).then((resMalzeme) => {
        for (var i = 0; i < resMalzeme.Data.length; i++) {
          var label = resMalzeme.Data[i].Adi;
          if (resMalzeme.Data[i].Olcubirimivalue || resMalzeme.Data[i].Aciklama) label += "("
          if (resMalzeme.Data[i].Olcubirimivalue) label += resMalzeme.Data[i].Olcubirimivalue
          if (resMalzeme.Data[i].Aciklama) label += " - " + resMalzeme.Data[i].Aciklama.slice(0, 25)
          if (resMalzeme.Data[i].Olcubirimivalue || resMalzeme.Data[i].Aciklama) label += ")"
          this.Malzemeler.push({
            id: resMalzeme.Data[i].Id,
            label: label,
          });

        }
      });
    }
  },
  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "9999",
    };
    this.ActionsGet({ "Service": "OMalzeme", "Page": Page }).then((resMalzeme) => {
        for (var i = 0; i < resMalzeme.Data.length; i++) {
          var label = resMalzeme.Data[i].Adi;
          this.MalzemeFullList.push({
            id: resMalzeme.Data[i].Id,
            label: label,
          });

        }
      });
    this.ActionsGet({ "Service": "OBirim/GetTreeByAnaBirim", "Page": Page }).then((res) => {
      this.Birimler .push({ id: 1, label: "Tümü", children: null });
      this.Birimler[0].children = JSON.parse(JSON.stringify(res.Data).replaceAll('"children":null,', ''));
      
    });
    this.ActionsSabitGet(201).then(res => {  
      for(var i=0; i<res.Data.length; i++)
        {
          this.Olcubirimleri.push ({Id:res.Data[i].Id,Value:res.Data[i].Value})
        }    
    }); 
    this.ActionsGet({ Service: "OPersonel/GetAllPersonel", Page: Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.Kullanicilar.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].AdSoyad,
        });

      }
    });
    this.ActionsGet({ "Service": "OMalzemeGrup", "Page": Page }).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.MalzemeGruplari.push({ Id: res.Data[i].Id, Value: res.Data[i].Adi })
      }
    });
    this.ActionsSabitGet(1548).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.Harcamatipleri.push({
          Id: res.Data[i].Id,
          Value: res.Data[i].Value,
        });
      }
    });
    this.ActionsSabitGet(1555).then((res) => {
      for (var i = 0; i < res.Data.length; i++) {
        this.Sartnametipleri.push({
          id: res.Data[i].Id,
          label: res.Data[i].Value,
        });
      }
    });


  }
};
</script> 
<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">


              <div class="row mb-2">
                <Form @submit.prevent="onSubmit">
                  <div class="row">
                    <div class="col md-3">
                      <forminput :FormDataType='{
                        FieldName: "Adi",
                        Field: "input",
                        FieldTitle: this.$t("sattalep.AddEdit.Baslik"),
                      }' :Value="FormData.Baslik" :v="$v.FormData.Baslik" @input="FormData.Baslik = $event" />
                    </div>
                    <div class="col md-3">
                      <formdate :FormDataType='{
                        FieldName: "Taleptarih",
                        Field: "input",
                        FieldTitle: this.$t("sattalep.AddEdit.Taleptarih"),
                        FieldType: "date",
                      }' :Value="FormData.Taleptarih" :v="$v.FormData.Taleptarih"
                        @input="FormData.Taleptarih = $event" />
                    </div>
                    <div class="col md-3">
                      <BirimSecimi 
                      :title_position="'mb-3'" 
                      :selected="FormData.Birimidler" :FormDataType='{
                        FieldName: "Birimidler",
                        Field: "birimcombobox",
                        FieldTitle: "Birim",
                        ComboDataArray: Birimler
                      }' :v="$v.FormData.Birimidler" :multiple="true" :BirimTipId="null"
                        @input="FormData.Birimidler = $event" />
                    </div>
                    <div class="col md-3">
                      <formdate :FormDataType='{
                        FieldName: "Taleptoplamasontarih",
                        Field: "input",
                        FieldTitle: this.$t("sattalep.AddEdit.Taleptoplamasontarih"),
                        FieldType: "date",
                      }' :Value="FormData.Taleptoplamasontarih" :v="$v.FormData.Taleptoplamasontarih"
                        @input="FormData.Taleptoplamasontarih = $event" />
                    </div>

                  </div>

                  <div class="row" v-if="0">
                    <div class="col md-4">
                      <formcombobox :FormDataType='{
                        FieldName: "Kullanicitasinirid",
                        Field: "combobox",
                        FieldTitle: this.$t("sattalep.AddEdit.Kullanicitasinirid"),
                        ComboDataArray: Kullanicilar,
                      }' :Value="FormData.Kullanicitasinirid" :v="$v.FormData.Kullanicitasinirid"
                        @input="FormData.Kullanicitasinirid = $event" />
                    </div>

                    <div class="col md-4">
                      <formcombobox :FormDataType='{
                        FieldName: "Kullanicigerceklestirmeid",
                        Field: "combobox",
                        FieldTitle: this.$t("sattalep.AddEdit.Kullanicigerceklestirmeid"),
                        ComboDataArray: Kullanicilar,
                      }' :Value="FormData.Kullanicigerceklestirmeid" :v="$v.FormData.Kullanicigerceklestirmeid"
                        @input="FormData.Kullanicigerceklestirmeid = $event" />
                    </div>
                    <div class="col md-4">
                      <formcombobox :FormDataType='{
                        FieldName: "Kullaniciharcamaid",
                        Field: "combobox",
                        FieldTitle: this.$t("sattalep.AddEdit.Kullaniciharcamaid"),
                        ComboDataArray: Kullanicilar,
                      }' :Value="FormData.Kullaniciharcamaid" :v="$v.FormData.Kullaniciharcamaid"
                        @input="FormData.Kullaniciharcamaid = $event" />
                    </div>
                  </div>

        <!--         <div class="row">
                    <div class="col md-4">
                      <formcombobox :FormDataType='{
                        FieldName: "Harcamatipid",
                        Field: "combobox",
                        FieldTitle: this.$t("sattalep.AddEdit.Harcamatipid"),
                        ComboDataArray: Harcamatipleri,
                      }' :Value="FormData.Harcamatipid" :v="$v.FormData.Harcamatipid"
                        @input="FormData.Harcamatipid = $event" />
                    </div>
                    <div class="col md-4">
                      <b-form-group class="mb-3" id="example text" label="Şartname Tipi" label-for="text">
                        <treeselect :multiple="true" :options="Sartnametipleri" :placeholder="$t('OrtakKullanim.seciniz')"
                          v-model="FormData.Sartnametip" :class="{ 'is-invalid': $v.FormData.Sartnametip.$error }" />
                        <treeselect-value :value="FormData.Sartnametip" />

                        <div v-if="$v.FormData.Sartnametip.$error" class="invalid-feedback">
                          <span v-if="$v.FormData.Sartnametip.required == false">{{ $t("ValidationMessage.required")
                          }}</span>
                        </div>
                      </b-form-group>
                    </div>

                    <div class="col md-4">
                      <formdate :FormDataType='{
                        FieldName: "Taleptoplamasontarih",
                        Field: "input",
                        FieldTitle: this.$t("sattalep.AddEdit.Taleptoplamasontarih"),
                        FieldType: "date",
                      }' :Value="FormData.Taleptoplamasontarih" :v="$v.FormData.Taleptoplamasontarih"
                        @input="FormData.Taleptoplamasontarih = $event" />
                    </div>


                  </div> --> 
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="text-sm-end">
                        <button class="btn btn-primary" type="submit">
                          {{ $t("sattalep.AddEdit.Button") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>

              <div class="row">
                <div class="col-xl-12">
                  <div class="card">
                    <div class="card-body">
                      <div class="row mb-2">
                        <Form @submit.prevent="onSubmitMalzeme">
                          <div class="row">
                            <div class="d-flex justify-content-between align-items-center">
                              <forminput :FormDataType='{
                                FieldName: "Sirano",
                                Field: "input",
                                FieldTitle: this.$t("sattalepmalzeme.AddEdit.Sirano"),
                                FieldType: "number"
                              }' :Value="FormDataMalzeme.Sirano" :v="$v.FormDataMalzeme.Sirano"
                                @input="FormDataMalzeme.Sirano = $event" style="width:80px" />
                              <formcombobox :FormDataType='{
                                FieldName: "Grupid",
                                Field: "combobox",
                                FieldTitle: this.$t("sattalep.AddEdit.Grupid"),
                                ComboDataArray: MalzemeGruplari,
                              }' :Value="FormDataMalzeme.Grupid" :v="$v.FormDataMalzeme.Grupid"
                                @input="FormDataMalzeme.Grupid = $event, malzemeleri_yukle(FormDataMalzeme.Grupid)" />

                              <b-form-group class="mb-3" id="example text" label="İhtiyaçlar" label-for="text"
                                style="width:280px">
                                <treeselect :disabled="AddEdit == 'Edit'" :multiple="false" :options="Malzemeler"
                                  :placeholder="$t('OrtakKullanim.seciniz')" v-model="FormDataMalzeme.Malzemeid" :class="{
                                    'is-invalid': $v.FormDataMalzeme.Malzemeid.$error,
                                  }" @input="malzeme_olcubirimi($event = FormDataMalzeme.Malzemeid)"/>

                                <treeselect-value :value="FormDataMalzeme.Malzemeid" />
                                <div v-if="$v.FormDataMalzeme.Malzemeid.$error" class="invalid-feedback">
                                  <span v-if="$v.FormDataMalzeme.Malzemeid.required == false">{{
                                    $t("ValidationMessage.required") }}</span>
                                </div>
                              </b-form-group>
                              <i class="fas fa-plus" id="button-1" @click="(MalzmeEkle = true), (TalepAddEdit = 'TalepAdd')"
                                v-b-modal.omalzeme ></i>
                                <b-tooltip target="button-1" title="Malzeme Ekle"></b-tooltip>
                                <formcombobox :FormDataType='{
                                FieldName: "Olcubirimi",
                                Field: "combobox",
                                FieldTitle: this.$t("sattalep.AddEdit.Olcubirimi"),
                                ComboDataArray: Olcubirimleri,
                              }' :Value="FormDataMalzeme.Olcubirimi" :v="$v.FormDataMalzeme.Olcubirimi"
                                @input="FormDataMalzeme.Olcubirimi = $event" />
                                
                              <forminput :FormDataType='{
                                FieldName: "Adet",
                                Field: "input",
                                FieldTitle: this.$t("sattalepmalzeme.AddEdit.Miktar"),
                                FieldType: "number"
                              }' :Value="FormDataMalzeme.Adet" :v="$v.FormDataMalzeme.Adet"
                                @input="FormDataMalzeme.Adet = $event" style="width:80px" />

                              <forminput :FormDataType='{
                                FieldName: "Aciklama",
                                Field: "textarea",
                                FieldTitle: this.$t("sattalepmalzeme.AddEdit.Aciklama")
                              }' :Value="FormDataMalzeme.Aciklama" :v="$v.FormDataMalzeme.Aciklama"
                                @input="FormDataMalzeme.Aciklama = $event" />

                              <div class="mt-2">
                                <button class="btn btn-pink" type="submit">
                                  {{ $t("sattalepmalzeme.AddEdit.Button") }}
                                </button>
                              </div>
                            </div>
                          </div>
                        </Form>
                        <div class="table-responsive">
                          <table class="table mb-0">
                            <thead class="table-light">
                              <tr>
                                <th>{{ $t("sattalepmalzeme.Table.Sirano") }}</th>
                                <th>{{ $t("sattalepmalzeme.Table.Malzemeid") }}</th>
                                <th>{{ $t("sattalepmalzeme.Table.Miktar") }}</th>
                                <th>{{ $t("sattalepmalzeme.Table.Aciklama") }}</th>
                                <th style="width: 100px; text-align: center;">{{ $t("sattalepmalzeme.Table.Islem") }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(Data, index) in MalzemeListesi" :key="index">
                                <th scope="row">{{ Data.Sirano }}</th>
                                <td>
                                  {{MalzemeFullList.filter(notification => notification.id.includes(Data.Malzemeid))[0].label}}
                                </td>
                                <td>{{ Data.Adet }}</td>
                                <td>{{ Data.Aciklama }}</td>
                                <td style="width: 100px; text-align: center;">
                                  <b-button-group>
                                    <b-button variant="danger" @click="MalzemeDelete(index)"><i
                                        class="far fa-trash-alt"></i></b-button>
                                  </b-button-group>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <omalzemeAddEdit v-if="MalzmeEkle" :AddEdit="TalepAddEdit" @TableUpdate="Get()" />
    </Layout>
  </Loader>
</template>
